import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Scrolltotop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [pathname]);

  return null;
}

export default Scrolltotop;